module.exports = __webpack_public_path__ + "static/media/img_28.48011799.png";